import { FC } from 'react';

import { PropsWithOnlyChildren } from 'app/types';

import AlertsContextProvider from './AlertsContext/Provider';
import AuthContextProvider from './AuthContext/Provider';
import GeneralContextProvider from './GeneralContext/Provider';
import NavigationContextProvider from './NavigationContext/Provider';

const ContextProvider: FC<PropsWithOnlyChildren> = ({ children }) => (
  <AlertsContextProvider>
    <AuthContextProvider>
      <NavigationContextProvider>
        <GeneralContextProvider>
          {children}
        </GeneralContextProvider>
      </NavigationContextProvider>
    </AuthContextProvider>
  </AlertsContextProvider>
);

export default ContextProvider;
